import React, { useEffect, useState } from "react";
import Sidebar from "../../../component/home/sidebar";
import WorkingHoursItem from "./components/WorkingHoursItem";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import { useDispatch } from "react-redux";
import { getWorkingHours, updateWorkingHours } from "../../../redux/actions/company";

const defaultWorkingHours = [
  {
    day: "monday",
    start_time: null,
    end_time: null,
    is_active: false,
  },
  {
    day: "tuesday",
    start_time: null,
    end_time: null,
    is_active: false,
  },
  {
    day: "wednesday",
    start_time: null,
    end_time: null,
    is_active: false,
  },
  {
    day: "thursday",
    start_time: null,
    end_time: null,
    is_active: false,
  },
  {
    day: "friday",
    start_time: null,
    end_time: null,
    is_active: false,
  },
  {
    day: "saturday",
    start_time: null,
    end_time: null,
    is_active: false,
  },
  {
    day: "Sunday",
    start_time: null,
    end_time: null,
    is_active: false,
  },
];

function WorkingHours() {
  const dispatch = useDispatch();
  const [isWorkHour, setIsWorkHour] = useState(false);
  const [isPrepone, setIsPrepone] = useState(false);
  const [workingHours, setWorkingHours] = useState([]);

  useEffect(() => {
    if (!isWorkHour) setIsPrepone(false);
  }, [isWorkHour]);

  useEffect(() => {
    const request = {
      onSuccess: (result) => {

        if(result.status){

          const workHours = result.data?.working_hours ? JSON.parse(result.data?.working_hours) : defaultWorkingHours;
          const isWorkHourCheck = result.data?.is_working_hours ? result.data?.is_working_hours : false;
          const isPreponeCheck = result.data?.is_prepone ? result.data?.is_prepone : false;

          setWorkingHours(workHours);
          setIsWorkHour(isWorkHourCheck);
          setIsPrepone(isPreponeCheck);
        }

      },
      onError: (error) => {
        console.log("error", error);
      },
    };
    dispatch(getWorkingHours(request));
  }, []);

  const handleSubmit = () => {
    const notSelected = workingHours.some(
      (item) =>
        item.is_active && (item.start_time === null || item.end_time === null)
    );

    if (notSelected) {
      swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content="Please select start time or end time for selected day."
          />
        ),
        buttons: false,
        closeOnClickOutside: true,
        closeOnEsc: true,
      });
      return;
    }

    const payload = {
      is_working_hours: isWorkHour,
      is_prepone: isPrepone,
      working_hours: workingHours,
    };

    dispatch(updateWorkingHours(payload, (res) => {
      if(res.status){
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content="Working hours is updated successfully."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      }else{
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content="Unable to update working hours."
            />
          ),
          buttons: false,
          closeOnClickOutside: true,
          closeOnEsc: true,
        });
      }
    }))

  };

  return (
    <>
      <div className="mt-4 sm:mx-6 lg:mx-8">
        <div className="h-full flex flex-col md:flex-row">
          <Sidebar />
          <div className="flex-auto px-5 bg-white max-h-full w-full md:w-2/3 space-y-6 relative">
            {/* Heading of page */}
            <h4 className="text-base font-semibold text-[#1E293B] leading-5 tracking-tight">
              Working Hours Configuration
            </h4>

            {/* Active hours Switch */}

            <div className="w-full px-5 py-3 flex flex-row justify-between items-center bg-[--bg-color-50] rounded-md border border-[--bg-color-100]">
              <div>
                <div className="font-inter font-bold text-[15px]">
                  Activate Working Hours
                </div>
                <div className="font-inter font-normal text-[15px]">
                  By activating working hours Shiperone will validate and modify
                  calculated end dates based on your working hours.
                </div>
              </div>
              <div>
                <div className="form-switch">
                  <input
                    type="checkbox"
                    checked={isWorkHour}
                    onChange={(e) => {
                      e.stopPropagation();
                      setIsWorkHour(!isWorkHour);
                    }}
                    id={"activehrs"}
                    className="sr-only"
                    // disabled={false}
                  />
                  <label htmlFor={"activehrs"} className="bg-slate-400">
                    <span
                      className="bg-white shadow-sm"
                      aria-hidden="true"
                    ></span>
                  </label>
                </div>
              </div>
            </div>

            {/* Working Hours Controllers */}

            <div className="w-full">
              <h4 className="text-base font-semibold text-[#1E293B] leading-5 tracking-tight mb-4">
                Working Hours
              </h4>
              <div className="space-y-4">
                {workingHours &&
                  workingHours.map((item, index) => (
                    <WorkingHoursItem
                      key={index}
                      {...item}
                      isWorkHour={isWorkHour}
                      setWorkingHours={setWorkingHours}
                    />
                  ))}
              </div>
            </div>

            {/* Active Time Changes Switch */}

            <div>
              <h4 className="text-base font-semibold text-[#1E293B] leading-5 tracking-tight mb-4">
                Logic of Time Change
              </h4>
              <div className="w-full px-5 py-3 flex flex-row justify-between items-center bg-[--bg-color-50] rounded-md border border-[--bg-color-100]">
                <div>
                  <div className="font-inter font-bold text-[15px]">
                    Automated Change of End Time
                  </div>
                  <div className="font-inter font-normal text-[15px]">
                    By default end times out of the working hours will be pushed
                    to the next possible time. Activate if you want to prepone
                    instead.
                  </div>
                </div>
                <div>
                  <div className="form-switch">
                    <input
                      type="checkbox"
                      checked={isPrepone}
                      onChange={(e) => {
                        e.stopPropagation();
                        if (isWorkHour) setIsPrepone(!isPrepone);
                      }}
                      id={"activeprepone"}
                      className="sr-only"
                      // disabled={false}
                    />
                    <label htmlFor={"activeprepone"} className="bg-slate-400">
                      <span
                        className="bg-white shadow-sm"
                        aria-hidden="true"
                      ></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-5 text-right">
              <button
                className="btn bg-[--bg-color-500] text-white hover:bg-[--bg-color-600] cursor-pointer mb-5"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSubmit();
                }}
              >
                Update Working Hours
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

WorkingHours.auth = {
  path: "/working-hours",
  role: ["super-admin", "admin"],
};
export default WorkingHours;
